import { render } from "./HajjMission.vue?vue&type=template&id=a5a84f86&scoped=true"
import script from "./HajjMission.vue?vue&type=script&lang=js"
export * from "./HajjMission.vue?vue&type=script&lang=js"

import "./HajjMission.vue?vue&type=style&index=0&id=a5a84f86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5a84f86"]])

export default __exports__